import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgResetmin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 4V1.333L4.667 4.668 8 8V5.333c2.207 0 4 1.794 4 4 0 2.207-1.793 4-4 4s-4-1.793-4-4H2.667A5.332 5.332 0 008 14.668a5.332 5.332 0 005.333-5.333A5.332 5.332 0 008 4z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgResetmin);
export { ForwardRef as ReactComponent };
